import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Invoice from '../../entities/invoice';
import Expense from '../../entities/expense';
import FlatFee from '../../entities/flatFee';
import FlatFeeMilestone from '../../entities/flatFeeMilestone';
import InvoiceBatch from '../../entities/invoiceBatch';
import InvoiceBatchItem from '../../entities/invoiceBatchItem';
import Task from '../../entities/task';
import Transaction from '../../entities/transaction';
export function deleteInvoice(invoice: Invoice, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = invoice.id;}
const _work = workingSet();
store.getState().expenses.getMappingFor('invoiceId', invoice.id).filter(expenseTemp => expenseTemp.status !== 'D').forEach(expenseTemp => {
const _expense = ((_work.get('expense:' + expenseTemp.id) ?? expenseTemp) as Expense).clone();
_expense.status = 'U';
_expense.addedOn = newHRTimestamp();
_expense.addedBy = getCurrentUserId();
_expense.importSource = targetImportSource;
_expense.importId = mergeId;
if (_expense.invoiceId === invoice.id) {
_expense.invoiceId = null;

}
_work.set('expense:' + _expense.id, _expense);
store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
});
store.getState().flatFees.getMappingFor('invoiceId', invoice.id).filter(flatFeeTemp => flatFeeTemp.status !== 'D').forEach(flatFeeTemp => {
const _flatFee = ((_work.get('flatFee:' + flatFeeTemp.id) ?? flatFeeTemp) as FlatFee).clone();
_flatFee.status = 'U';
_flatFee.addedOn = newHRTimestamp();
_flatFee.addedBy = getCurrentUserId();
_flatFee.importSource = targetImportSource;
_flatFee.importId = mergeId;
if (_flatFee.invoiceId === invoice.id) {
_flatFee.invoiceId = null;

}
_work.set('flatFee:' + _flatFee.id, _flatFee);
store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
});
store.getState().flatFeeMilestones.getMappingFor('invoiceId', invoice.id).filter(flatFeeMilestoneTemp => flatFeeMilestoneTemp.status !== 'D').forEach(flatFeeMilestoneTemp => {
const _flatFeeMilestone = ((_work.get('flatFeeMilestone:' + flatFeeMilestoneTemp.id) ?? flatFeeMilestoneTemp) as FlatFeeMilestone).clone();
_flatFeeMilestone.status = 'U';
_flatFeeMilestone.addedOn = newHRTimestamp();
_flatFeeMilestone.addedBy = getCurrentUserId();
_flatFeeMilestone.importSource = targetImportSource;
_flatFeeMilestone.importId = mergeId;
if (_flatFeeMilestone.invoiceId === invoice.id) {
_flatFeeMilestone.invoiceId = null;

}
_work.set('flatFeeMilestone:' + _flatFeeMilestone.id, _flatFeeMilestone);
store.dispatch(Actions.FlatFeeMilestoneActions.saveFlatFeeMilestoneQueue(_flatFeeMilestone));
});
store.getState().invoiceBatches.getMappingFor('invoiceId', invoice.id).filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D').forEach(invoiceBatchTemp => {
const _invoiceBatch = ((_work.get('invoiceBatch:' + invoiceBatchTemp.id) ?? invoiceBatchTemp) as InvoiceBatch).clone();
_invoiceBatch.status = 'U';
_invoiceBatch.addedOn = newHRTimestamp();
_invoiceBatch.addedBy = getCurrentUserId();
_invoiceBatch.importSource = targetImportSource;
_invoiceBatch.importId = mergeId;
_invoiceBatch.invoiceIds = _invoiceBatch.invoiceIds?.filter(id => id !== invoice.id) || [];

_work.set('invoiceBatch:' + _invoiceBatch.id, _invoiceBatch);
store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
});
store.getState().invoiceBatchItems.getMappingFor('invoiceId', invoice.id).filter(invoiceBatchItemTemp => invoiceBatchItemTemp.status !== 'D').forEach(invoiceBatchItemTemp => {
const _invoiceBatchItem = ((_work.get('invoiceBatchItem:' + invoiceBatchItemTemp.id) ?? invoiceBatchItemTemp) as InvoiceBatchItem).clone();
_invoiceBatchItem.status = 'U';
_invoiceBatchItem.addedOn = newHRTimestamp();
_invoiceBatchItem.addedBy = getCurrentUserId();
_invoiceBatchItem.importSource = targetImportSource;
_invoiceBatchItem.importId = mergeId;
if (_invoiceBatchItem.invoiceId === invoice.id) {
_invoiceBatchItem.invoiceId = null;

}
_work.set('invoiceBatchItem:' + _invoiceBatchItem.id, _invoiceBatchItem);
store.dispatch(Actions.InvoiceBatchItemActions.saveInvoiceBatchItemQueue(_invoiceBatchItem));
});
store.getState().tasks.getMappingFor('invoiceId', invoice.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.invoiceId === invoice.id) {
_task.invoiceId = null;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().transactions.getMappingFor('invoiceId', invoice.id).filter(transactionTemp => transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
if (_transaction.invoiceId === invoice.id) {
_transaction.invoiceId = null;

}
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});



invoice.status = 'D';
invoice.addedOn = newHRTimestamp();
invoice.addedBy = getCurrentUserId();
invoice.importSource = targetImportSource;
invoice.importId = mergeId;
store.dispatch(Actions.InvoiceActions.removeInvoiceQueue(invoice));
}
export function replaceInvoice(invoice: Invoice, replaceWith: Invoice, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = invoice.id;}
const _work = workingSet();
store.getState().expenses.getMappingFor('invoiceId', invoice.id).filter(expenseTemp => expenseTemp.status !== 'D').forEach(expenseTemp => {
const _expense = ((_work.get('expense:' + expenseTemp.id) ?? expenseTemp) as Expense).clone();
_expense.status = 'U';
_expense.addedOn = newHRTimestamp();
_expense.addedBy = getCurrentUserId();
_expense.importSource = targetImportSource;
_expense.importId = mergeId;
if (_expense.invoiceId === invoice.id) {
_expense.invoiceId = replaceWith.id;

}
_work.set('expense:' + _expense.id, _expense);
store.dispatch(Actions.ExpenseActions.saveExpenseQueue(_expense));
});
store.getState().flatFees.getMappingFor('invoiceId', invoice.id).filter(flatFeeTemp => flatFeeTemp.status !== 'D').forEach(flatFeeTemp => {
const _flatFee = ((_work.get('flatFee:' + flatFeeTemp.id) ?? flatFeeTemp) as FlatFee).clone();
_flatFee.status = 'U';
_flatFee.addedOn = newHRTimestamp();
_flatFee.addedBy = getCurrentUserId();
_flatFee.importSource = targetImportSource;
_flatFee.importId = mergeId;
if (_flatFee.invoiceId === invoice.id) {
_flatFee.invoiceId = replaceWith.id;

}
_work.set('flatFee:' + _flatFee.id, _flatFee);
store.dispatch(Actions.FlatFeeActions.saveFlatFeeQueue(_flatFee));
});
store.getState().flatFeeMilestones.getMappingFor('invoiceId', invoice.id).filter(flatFeeMilestoneTemp => flatFeeMilestoneTemp.status !== 'D').forEach(flatFeeMilestoneTemp => {
const _flatFeeMilestone = ((_work.get('flatFeeMilestone:' + flatFeeMilestoneTemp.id) ?? flatFeeMilestoneTemp) as FlatFeeMilestone).clone();
_flatFeeMilestone.status = 'U';
_flatFeeMilestone.addedOn = newHRTimestamp();
_flatFeeMilestone.addedBy = getCurrentUserId();
_flatFeeMilestone.importSource = targetImportSource;
_flatFeeMilestone.importId = mergeId;
if (_flatFeeMilestone.invoiceId === invoice.id) {
_flatFeeMilestone.invoiceId = replaceWith.id;

}
_work.set('flatFeeMilestone:' + _flatFeeMilestone.id, _flatFeeMilestone);
store.dispatch(Actions.FlatFeeMilestoneActions.saveFlatFeeMilestoneQueue(_flatFeeMilestone));
});
store.getState().invoiceBatches.getMappingFor('invoiceId', invoice.id).filter(invoiceBatchTemp => invoiceBatchTemp.status !== 'D').forEach(invoiceBatchTemp => {
const _invoiceBatch = ((_work.get('invoiceBatch:' + invoiceBatchTemp.id) ?? invoiceBatchTemp) as InvoiceBatch).clone();
_invoiceBatch.status = 'U';
_invoiceBatch.addedOn = newHRTimestamp();
_invoiceBatch.addedBy = getCurrentUserId();
_invoiceBatch.importSource = targetImportSource;
_invoiceBatch.importId = mergeId;
_invoiceBatch.invoiceIds = _invoiceBatch.invoiceIds?.map(id => (id === invoice.id) ? replaceWith.id : id) || [];

_work.set('invoiceBatch:' + _invoiceBatch.id, _invoiceBatch);
store.dispatch(Actions.InvoiceBatchActions.saveInvoiceBatchQueue(_invoiceBatch));
});
store.getState().invoiceBatchItems.getMappingFor('invoiceId', invoice.id).filter(invoiceBatchItemTemp => invoiceBatchItemTemp.status !== 'D').forEach(invoiceBatchItemTemp => {
const _invoiceBatchItem = ((_work.get('invoiceBatchItem:' + invoiceBatchItemTemp.id) ?? invoiceBatchItemTemp) as InvoiceBatchItem).clone();
_invoiceBatchItem.status = 'U';
_invoiceBatchItem.addedOn = newHRTimestamp();
_invoiceBatchItem.addedBy = getCurrentUserId();
_invoiceBatchItem.importSource = targetImportSource;
_invoiceBatchItem.importId = mergeId;
if (_invoiceBatchItem.invoiceId === invoice.id) {
_invoiceBatchItem.invoiceId = replaceWith.id;

}
_work.set('invoiceBatchItem:' + _invoiceBatchItem.id, _invoiceBatchItem);
store.dispatch(Actions.InvoiceBatchItemActions.saveInvoiceBatchItemQueue(_invoiceBatchItem));
});
store.getState().tasks.getMappingFor('invoiceId', invoice.id).filter(taskTemp => taskTemp.status !== 'D').forEach(taskTemp => {
const _task = ((_work.get('task:' + taskTemp.id) ?? taskTemp) as Task).clone();
_task.status = 'U';
_task.addedOn = newHRTimestamp();
_task.addedBy = getCurrentUserId();
_task.importSource = targetImportSource;
_task.importId = mergeId;
if (_task.invoiceId === invoice.id) {
_task.invoiceId = replaceWith.id;

}
_work.set('task:' + _task.id, _task);
store.dispatch(Actions.TaskActions.saveTaskQueue(_task));
});
store.getState().transactions.getMappingFor('invoiceId', invoice.id).filter(transactionTemp => transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
if (_transaction.invoiceId === invoice.id) {
_transaction.invoiceId = replaceWith.id;

}
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});



return invoice;
}
export function deleteImpactInvoice(invoice: Invoice) {
const impacts: string[] = [];
const state = store.getState();
const expenseInvoiceIdImpact = state.expenses.getMappingFor('invoiceId', invoice.id).filter(expense => expense.status !== 'D');
expenseInvoiceIdImpact.forEach(() => impacts.push('expenses'));
const flatFeeInvoiceIdImpact = state.flatFees.getMappingFor('invoiceId', invoice.id).filter(flatFee => flatFee.status !== 'D');
flatFeeInvoiceIdImpact.forEach(() => impacts.push('flatFees'));
const flatFeeMilestoneInvoiceIdImpact = state.flatFeeMilestones.getMappingFor('invoiceId', invoice.id).filter(flatFeeMilestone => flatFeeMilestone.status !== 'D');
flatFeeMilestoneInvoiceIdImpact.forEach(() => impacts.push('flatFeeMilestones'));
const invoiceBatchInvoiceIdsImpact = state.invoiceBatches.getMappingFor('invoiceId', invoice.id).filter(invoiceBatch => invoiceBatch.status !== 'D');
invoiceBatchInvoiceIdsImpact.forEach(() => impacts.push('invoiceBatches'));
const invoiceBatchItemInvoiceIdImpact = state.invoiceBatchItems.getMappingFor('invoiceId', invoice.id).filter(invoiceBatchItem => invoiceBatchItem.status !== 'D');
invoiceBatchItemInvoiceIdImpact.forEach(() => impacts.push('invoiceBatchItems'));
const taskInvoiceIdImpact = state.tasks.getMappingFor('invoiceId', invoice.id).filter(task => task.status !== 'D');
taskInvoiceIdImpact.forEach(() => impacts.push('tasks'));
const transactionInvoiceIdImpact = state.transactions.getMappingFor('invoiceId', invoice.id).filter(transaction => transaction.status !== 'D');
transactionInvoiceIdImpact.forEach(() => impacts.push('transactions'));



return util.countDistinct(impacts);
}
